export const packageJson = `{
  "name": "vendure-demo",
  "version": "1.0.0",
  "description": "A demo Vendure e-commerce application",
  "main": "dist/index.js",
  "scripts": {
    "compile": "tsc",
    "dev": "ts-node src/index.ts",
    "start": "node dist/index.js",
    "populate": "vendure populate -s"
  },
  "dependencies": {
    "@vendure/admin-ui-plugin": "^3.0.0",
    "@vendure/asset-server-plugin": "^3.0.0",
    "@vendure/core": "^3.0.0",
    "@vendure/email-plugin": "^3.0.0",
    "@vendure/harden-plugin": "^3.0.0",
    "@vendure/graphiql-plugin": "^3.0.0",
    "better-sqlite3": "^11.0.0",
    "fs-extra": "^11.2.0"
  },
  "devDependencies": {
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^20.0.0",
    "@vendure/cli": "^3.0.0",
    "ts-node": "^10.9.2",
    "typescript": "^5.0.0"
  },
  "keywords": ["vendure", "ecommerce", "demo"],
  "author": "Vendure",
  "license": "GPL-3.0-or-later",
  "private": true,
  "overrides": {
    "graphql": "16.9.0"
  }
}
`
